export enum SubscriptionChannel {
  Stripe = "Stripe",
}
